import {timeFormat} from '@/utils'

export default function () {
  const { scoringMethod } = this.reviewGroupInfo
  return [
    {
      title: '轮次序号',
      width: 76,
      [$field]: 'reviewRoundNum'
    },
    {
      title: '打分人',
      [$field]: 'memberUserName'
    },
    scoringMethod == 'DFFS01' ? {
      title: '打分',
      width: 50,
      [$field]: 'reviewScore'
    }: null,
    scoringMethod == 'DFFS02' ? {
      title: '投票',
      width: 50,
      [$field]: 'reviewVoteNum'
    }: null,
    scoringMethod == 'DFFS03' ? {
      title: '定级',
      width: 50,
      [$field]: 'reviewRank',
      render: (h, {row}) => {
        return h('span', this.dictCode['BOE37'][row.reviewRank])
      }
    } : null,
    {
      title: '意见',
      [$field]: 'reviewOpinion'
    },
    {
      title: '提交时间',
      width: 90,
      [$field]: 'lastModifyTime',
      render: (h, {row}) => {
        return h('span', row.lastModifyTime ? timeFormat(row.lastModifyTime) : '')
      }
    }
  ].filter(v => v)
}